let date = new Date().getFullYear();
let age = date - 2002;

const aboutData = [
  {
    title: "Name",
    desc: "Priyansh Pandey",
  },
  {
    title: "Degree",
    desc: "Major in cse",
  },
  {
    title: "YOB",
    desc: 2002,
  },
  {
    title: "Email",
    desc: "2028186@kiit.ac.in",
  },
  {
    title: "Age",
    desc: age,
  },
  {
    title: "Freelance",
    desc: "Available",
  },
];

export default aboutData;
